"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTABLE_LLAMADAS_SALIENTES_BLOQUEADAS_COLUMNS_MAP = void 0;
exports.SORTABLE_LLAMADAS_SALIENTES_BLOQUEADAS_COLUMNS_MAP = {
    fecha: 'calldate',
    destino: 'numero',
    origen: 'src',
    ip_origen: 'srcip',
};
